import CharacterSearchFilters from "components/common/character/CharacterSearchFilters";
import { useTopicRelateAnswer } from "./provider/TopicRelateAnswer";
import { CharacterResult } from "common/character/dto/CharacterResult";
import SearchResultList, {
  PageNavigation,
} from "components/common/SearchResultList";
import React from "react";
import { CHARACTER_PER_PAGE_MAX } from "constant/character";
import RelatePlayCharItem from "./RelatePlayCharItem";

const RelatePlayCharacters = () => {
  const { topicCharacters, topicAnswerCharacters } = useTopicRelateAnswer();
  const [pageNum, setPageNum] = React.useState<number>(0);
  const rowsPerPageHandle = React.useCallback(
    (limit: number) => {
      // setSearchParams({ ...searchParams, limit });
    },
    [topicCharacters]
  );
  const listCharacters = React.useMemo(() => {
    const skip = pageNum * CHARACTER_PER_PAGE_MAX;
    const liCharacters = topicAnswerCharacters.slice(
      skip,
      skip + CHARACTER_PER_PAGE_MAX
    );
    return liCharacters;
  }, [topicAnswerCharacters, pageNum]);

  const skipFromPageNum = (pageNum: number): number => {
    let result: number = 0;
    if (pageNum > 0) {
      result = pageNum * CHARACTER_PER_PAGE_MAX;
    }
    console.log("skipFromPageNum pageNum, result", pageNum, result);

    return result;
  };

  const pageNavigationHandle = (navPageNum: number) => {
    setPageNum(navPageNum);
  };
  const pageNavigation: PageNavigation = {
    resTotal: topicAnswerCharacters.length,
    limit: CHARACTER_PER_PAGE_MAX,
    skip: pageNum * CHARACTER_PER_PAGE_MAX,
    pageNavigationHandle,
    rowsPerPageHandle,
  };

  return (
    <>
      <SearchResultList<CharacterResult>
        renderSingle={(character: CharacterResult) => (
          <RelatePlayCharItem
            character={character}
            key={`character_${character.id}`}
          />
        )}
        results={listCharacters}
        pageNavigation={pageNavigation}
      />
    </>
  );
};

export default RelatePlayCharacters;
